import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { RibbonStakingRewardsFactory } from "../codegen/RibbonStakingRewardsFactory";
import { VaultLiquidityMiningMap, } from "../constants/constants";
import { useWeb3Context } from "./web3Context";
export var getStakingReward = function (library, vaultOption, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    var provider = useSigner ? library.getSigner() : library;
    if (!VaultLiquidityMiningMap.lm[vaultOption]) {
        return null;
    }
    return RibbonStakingRewardsFactory.connect(VaultLiquidityMiningMap.lm[vaultOption], provider);
};
var useStakingReward = function (vaultOption) {
    var _a = useWeb3React(), active = _a.active, library = _a.library;
    var provider = useWeb3Context().provider;
    var _b = useState(null), stakingReward = _b[0], setStakingReward = _b[1];
    useEffect(function () {
        if (provider) {
            var vault = getStakingReward(library || provider, vaultOption, active);
            setStakingReward(vault);
        }
    }, [provider, active, library, vaultOption]);
    return stakingReward;
};
export default useStakingReward;
//# sourceMappingURL=useStakingReward.js.map